import React from 'react';
import style from './RelatedSitesDropDown.scss';
import { Box, DropdownBase, TextButton } from 'wix-style-react';
import { Text } from '../../../PageElements/Text';
import ChevronDown from 'wix-ui-icons-common/ChevronDown';

export const RelatedSitesDropDown = ({ links, onSelectedSite }) => {
  const getActiveLink = () => {
    const activeLink = links.find(({ active }) => active);
    return activeLink ? activeLink : links[0];
  };

  const setBoxBackground = ({ selected, hovered }) =>
    (selected && hovered && '#669BFF') ||
    (selected && '#0059FF') ||
    (hovered && '#CCDEFF') ||
    '#FFFFFF';

  const customBuilderFunction = ({ id, name }) => ({
    id,
    overrideOptionStyle: true,
    value: ({ selected, hovered }) => (
      <Box
        backgroundColor={setBoxBackground({ selected, hovered })}
        padding="6px 24px"
      >
        <Text weight="normal" light={selected}>
          {name}
        </Text>
      </Box>
    ),
  });

  const options = links.map(({ name, url }) =>
    customBuilderFunction({
      id: url,
      name,
    }),
  );

  return (
    <div className={style.dropDownWrapper}>
      <Text
        tagName="span"
        size="small"
        weight="normal"
        secondary
        className={style.currentSiteText}
      >
        Current site:
      </Text>
      <DropdownBase
        onSelect={onSelectedSite}
        options={options}
        selectedId={getActiveLink().url}
        placement="bottom-start"
        dynamicWidth
        animate
        minWidth={242}
        maxHeight="500px"
      >
        {({ toggle }) => {
          return (
            <TextButton
              skin="dark"
              suffixIcon={<ChevronDown />}
              onClick={toggle}
              weight="normal"
              className={style.dropDownText}
            >
              {getActiveLink().name}
            </TextButton>
          );
        }}
      </DropdownBase>
    </div>
  );
};
